import React, { useState, useContext, useEffect } from 'react'
import Loader from "react-loader-spinner";
import tagManager from "react-gtm-module"
import useDataLayer from '../../../hooks/useDataLayer';
import { captureEvent } from 'event-service/modules/capture';
import { ModalVehicleContext } from '../storage/VehicleContext';
import FinanceCalculator from '../../../Modules/financeCalculator';
import useRenderizable from '../hooks/useVehicleContextValidator';
import mfc from '../modules/modalFormClient';

import "../../contact/ContactForm.scss"
import view from "./form.module.scss"
import grid from "../../../scss/flexboxgrid.module.scss"
import calc from "../financing/calculator.module.scss"

function FinanceForm(props) {
  const [context] = useContext(ModalVehicleContext)
  const { finalPrice, vehicleInfo } = props.contextualized ? context : props
  const { leadURL, siteId, disclaimerFinanceApp,gtmId } = props
  const pushToDataLayer = useDataLayer()
  const requiredFields = ["VIN", "StockNumber", "Year", "Make", "Model", "Trim"]
  const renderizable = useRenderizable({ finalPrice, vehicleInfo }, requiredFields)
  const isRenderizable = props.contextualized ? renderizable : true

  const filterLabels = () => Object.fromEntries(
    requiredFields.map(element => [element, vehicleInfo[element]])
  )

  const [fields, setFields] = useState({
    firstName: null, lastName: null, email: null, phoneNumber: null, comments: null,
    downpayment: null, purchaseType: null,
    siteId, pageSource: props.pageSource, pageURL: props.pageURL
  })

  const [error, setError] = useState([])

  const [statusMsg, setStatusMsg] = useState("")
  const [loading, isLoading] = useState(false)
  const [disclaimer, setDisclaimer] = useState(false)
  const [engagement, setEngagement] = useState(false)

  useEffect(() => {
    if (engagement) {
      captureEvent({
        event: 'asc_form_engagement',
        comm_type: 'form',
        comm_status: 'start',
        element_text: engagement?.innerText,
        department: 'sales',
        form_name: 'Finance Form',
        form_type: 'sales',
        item_id:  vehicleInfo.VIN,
        item_number: `${vehicleInfo.Year} ${vehicleInfo.Make} ${vehicleInfo.Model} ${vehicleInfo.Trim}`,
        item_price: `${finalPrice}`,
        item_condition: `${vehicleInfo.IsNew ? 'New' : 'Used'}`,
        item_year: vehicleInfo.Year,
        item_make: vehicleInfo.Make,
        item_model: vehicleInfo.Model,
        item_variant: vehicleInfo.Trim,
        item_color: vehicleInfo.ExteriorColor,
        item_type:'vehicle',
        item_category: vehicleInfo.BodyType,
        item_fuel_type: vehicleInfo.EngineFuelType,
        item_inventory_date: vehicleInfo.InStockDate,
      }, {
        handlers: ['ASC']
      }).then(res => console.log(res)).catch(err => console.log(err))
    }
  }, [engagement])

  const handleTextInput = (name, value) => {
    const isErrored = error.indexOf(name)
    if(isErrored > -1){
      const _error = [...error]
      _error.splice(isErrored, 1)
      setError(_error)
    }

    setStatusMsg("")
    setFields({ ...fields, ...{ [name]: value } })
  }

  const phoneMask = (e) => {
    var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
  }

  const submitForm = async (e) => {
    e.preventDefault()

    const missing = mfc.validateForm(fields, ['firstName', 'lastName', 'email', 'phoneNumber'])
    if (missing.length > 0) {
      setError([...missing])
      return setStatusMsg("One or more fields are missing!")
    }

    isLoading(true)

    const body = { ...fields, vehicle: filterLabels() }
    const result = await mfc.sendForm(leadURL, body)
    if (result.hasOwnProperty("error")) {
      setStatusMsg("Uh oh! Something went wrong, please try again!")
    } else {
      captureEvent({
        event: 'asc_form_submission_sales',
        comm_type: 'form',
        comm_outcome: 'crm_update',
        submission_id: `${result.result.data.LeadID.id}`,
        element_text: 'submit',
        department: 'sales',
        form_name: 'Finance Form',
        form_type: 'sales',
        item_id:  vehicleInfo.VIN,
        item_number: `${vehicleInfo.Year} ${vehicleInfo.Make} ${vehicleInfo.Model} ${vehicleInfo.Trim}`,
        item_price: `${finalPrice}`,
        item_condition: `${vehicleInfo.IsNew ? 'New' : 'Used'}`,
        item_year: vehicleInfo.Year,
        item_make: vehicleInfo.Make,
        item_model: vehicleInfo.Model,
        item_variant: vehicleInfo.Trim,
        item_color: vehicleInfo.ExteriorColor,
        item_type:'vehicle',
        item_category: vehicleInfo.BodyType,
        item_fuel_type: vehicleInfo.EngineFuelType,
        item_inventory_date: vehicleInfo.InStockDate,
      }, {
        handlers: ['ASC']
      }).then(res => console.log(res)).catch(err => console.log(err));
      pushToDataLayer("form-submission", result)
      pushToDataLayer("finance", result)
      setStatusMsg("Success! The message has been sent!")
    }
    
    isLoading(false)
  }

  const [isOpen, toggleOpen] = useState([false, false, false, false, false, false, false])

  const toggleMenu = (idx) => {
    const _isOpen = isOpen.map((val, jdx) => {
      return idx == jdx ? !val : false
    })
    if (idx === 3) {
      document.querySelector('.more-filters').classList.toggle('more-filters_visible')
    }
    toggleOpen(_isOpen)
  }

  const hideMenus = () => {
    const _isOpen = isOpen.map(() => (false))
    toggleOpen(_isOpen)
    //document.querySelector('.more-filters').classList.remove('more-filters_visible')
  }

  function getStorageItem(item) {
    return (typeof localStorage.getItem !== 'undefined' ? localStorage.getItem(item) : "[]")
  }

  function setStorageItem(item, value) {
    typeof localStorage.setItem !== 'undefined'
      ? localStorage.setItem(item, value)
      : console.log('no localStorage')
  }

  return (
    isRenderizable && (
      <div className={`contact-formCont ${view["contact-form"]}`}>

        <div className={`contact-inputCont ${grid["col-md-12"]} ${grid["col-sm-12"]}`} style={{ flexBasis: "100%" }}>
          <label>Price</label>
          <p>{finalPrice > 0 ? FinanceCalculator.formatLocale(finalPrice) : "Call For Price"}</p>
        </div>

        <div className={`contact-inputCont ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Down Payment"})}>
          <label htmlFor="downpayment">Down Payment</label>
          <input className="contact-input" id="downpayment" name="downpayment" type="number" min="0" step="any" placeholder=""
            onChange={(e) => handleTextInput(e.target.name, e.target.value)} />
        </div>

        <div className={`contact-inputCont ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Purchase Type"})}>
          <label htmlFor="purchaseType">Purchase Type</label>
          <ul className="dropdown-sorting" onMouseLeave={hideMenus} onClick={() => toggleMenu(6)} style={{ padding: "0 0 10px 0", height: "40px" }}>
            <li className="dropdown-v1 srp-dropdown__model" onMouseLeave={hideMenus}
              onClick={() => { toggleMenu(6); handleTextInput('purchaseType', getStorageItem("finance:Type")) }} style={{ height: "40px" }}>
              <div className="sr-dropdown__inner">
                <p className="sr-dropdown__name" style={{ marginTop: "3px" }}>{getStorageItem("finance:Type") ?? "Lease"}</p>
                <input hidden id="purchaseType" name="purchaseType" value={getStorageItem("finance:Type")}
                  onChange={(e) => handleTextInput(e.target.name, e.target.value)} />
              </div>
              {isOpen[6] &&
                (<ul className="sub-dropdown-v1 search-dropdown" style={{ top: "40px" }}>
                  <li className="sub-dropdown-v1__item" onClick={() => { toggleMenu(6); setStorageItem("finance:Type", "Lease"); }}>Lease</li>
                  <li className="sub-dropdown-v1__item" onClick={() => { toggleMenu(6); setStorageItem("finance:Type", "Finance"); }}>Finance</li>
                  <li className="sub-dropdown-v1__item" onClick={() => { toggleMenu(6); setStorageItem("finance:Type", "Cash"); }}>Cash</li>
                </ul>)}
            </li>
          </ul>
        </div>

        <div className={`contact-inputCont ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "First Name"})}>
          <label htmlFor="firstName">First Name *</label>
          <input className="contact-input" id="firstName" name="firstName" placeholder=""
          style={{ border: error.indexOf("firstName") > -1 && "1px solid red"}}
            onChange={(e) => handleTextInput(e.target.name, e.target.value)} />
        </div>

        <div className={`contact-inputCont ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Last Name"})}>
          <label htmlFor="lastName">Last Name *</label>
          <input className="contact-input" id="lastName" name="lastName" placeholder=""
            style={{ border: error.indexOf("lastName") > -1 && "1px solid red"}}
            onChange={(e) => handleTextInput(e.target.name, e.target.value)} />
        </div>

        <div className={`contact-inputCont contact-phone ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Phone"})}>
          <label htmlFor="phoneNumber">Phone *</label>
          <input className="contact-input" type="tel" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
            id="phoneNumber" name="phoneNumber" placeholder="(555) 555-5555"
            style={{ border: error.indexOf("phoneNumber") > -1 && "1px solid red"}}
            onChange={(e) => handleTextInput(e.target.name, e.target.value)}
            onInput={phoneMask}
          />
        </div>

        <div className={`contact-inputCont ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Email"})}>
          <label htmlFor="email">Email *</label>
          <input className="contact-input" type="email" id="email" name="email" placeholder=""
            style={{ border: error.indexOf("email") > -1 && "1px solid red"}}
            onChange={(e) => handleTextInput(e.target.name, e.target.value)} />
        </div>

        <div className="contact-inputCont contact-comment" style={{ marginRight: "0" }} onClick={() => setEngagement({innerText: "Comment"})}>
          <label htmlFor="comments">Comment</label>
          <textarea className="contact-input" id="comments" name="comments" placeholder=""
            onChange={(e) => handleTextInput(e.target.name, e.target.value)} />
        </div>
        {disclaimerFinanceApp.length > 0 &&
          <section className={calc["disclaimer-wrap"]}>
            <p className={calc["disclaimer-title"]}>
              Disclaimer
            </p>
            <div className={calc["disclaimer"]}
              dangerouslySetInnerHTML={{ __html: disclaimerFinanceApp }} />
          </section>
        }
        <div className="contact-inputCont contact-border">
          <div className={`contact-response ${statusMsg.length && "contact-failure"}`}>
            {statusMsg}
          </div>
          <button className="contact-button" onClick={submitForm}>
            {loading === false ? "SUBMIT" :
              <Loader type="ThreeDots" color="white" height={12} width={12} />
            }
          </button>
        </div>
      </div>
    )
  )
}

FinanceForm.defaultProps = {
  leadURL: "",
  disclaimerFinanceApp: "<p></p>",
  finalPrice: 0,
  vehicleInfo: {}
}

export default FinanceForm